import { parse, isAfter } from 'date-fns'

type TimeArrayType = {
  id: string
  time: string
}

export const filterOutPastTimes = (
  timeArray: TimeArrayType[],
  selectedDate: Date,
  timeZoneSelected: string
): TimeArrayType[] => {
  if (!timeZoneSelected) {
    return timeArray
  }

  const currentDate = new Date(
    new Date().toLocaleString('en-US', { timeZone: timeZoneSelected })
  )

  const selectedDateToTimeZone = new Date(
    selectedDate.toLocaleString('en-US', { timeZone: timeZoneSelected })
  )

  if (isAfter(selectedDateToTimeZone, currentDate)) {
    return timeArray
  }

  return timeArray.filter(({ time }) => {
    const objTime = parse(time, 'HH:mm', currentDate)

    return isAfter(objTime, currentDate)
  })
}
